import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { GlobalsService } from 'src/app/globals';
import { DialogService } from 'src/app/services/dialog.service';
import { NavbarService } from 'src/app/services/navbar.service';
import { WalletConnectService } from 'src/app/services/wallet-connect.service';

declare const window: any;

@Component({
  selector: 'app-pending-transaction',
  templateUrl: './pending-transaction.component.html',
  styleUrls: ['./pending-transaction.component.css']
})
export class PendingTransactionComponent implements OnInit {

  hash: string = '';
	transaction: any;
  transactionStatus: any;
  // transactionData: any;
  isChecking: boolean = false;
  isUsd: boolean = false;
  eventCurRate: number;
  usdCurRate: number;
  transaction_fee: number;
  ticketsCurrency: string;
  chainCurrency: string;
  ticketsPrice: string;
  ticketsTotal: string;
  ticketsAmount: number;
  ticketPrice: number;
  eventName: string = '';
  totalTickets: any = '';
  userEmail: string = '';
  eventId: string = '';
  prevStates: any[] = [];
  networkName: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private dialogService: DialogService,
    private walletConnectService: WalletConnectService,
    public globals: GlobalsService,
    private navbarService: NavbarService,
    private clipboardService: ClipboardService,
    private router: Router) { }

  ngOnInit(): void {
    this.navbarService.setIsNewUi(true);
    this.activatedRoute.params.subscribe(params => {
			this.hash = params['hash'];
      // console.log('Get transactiom', this.hash, params);
		});
    if (window.Web3) {
      // console.log('Web3 Detected! ' + window.web3);
      this.setNewProvider();
    } else {
      window.addEventListener('load', () => {
        // console.log('Web3 Detect');
        if (typeof window.Web3 !== 'undefined') {
            // console.log('Web3 Detected! ' + window.Web3);
            this.setNewProvider();
        }
      });
    }
  }

  setNewProvider() {
    this.walletConnectService.setNewProvider().then(provider => {
      // console.log("New provider is", provider);
      if (provider) {
        this.getTransactionByUrl();
      }
    });
  }

  getTransactionByUrl() {
    this.transactionStatus = 'Pending...';
    this.isChecking = true;
    let pendingTransaction = {};
    if(this.hash) {
      this.walletConnectService.getTransactionByUrlHash(this.hash).subscribe((response: any) => {
        // console.log('get Transaction By Url Hash', response);
        if (response.code === 'pending') { // response.data && response.data.transaction_status === 0
          this.transaction = response.data;
          if (this.transaction && this.transaction.transaction_data && this.transaction.transaction_data.value) {

            this.isUsd = this.transaction.transaction_data.tickets_currency === 'usd';
            this.ticketsPrice = this.walletConnectService.getShadowFromWei(this.transaction.transaction_data.value.toString());
            this.transaction_fee = this.transaction.transaction_data.transacción_fee || this.transaction?.transaction_data?.transaction_fee;
            this.ticketsTotal = this.transaction.transaction_data.transaction_amount; // this.ticketsPrice + this.transaction_fee
            this.ticketsCurrency = this.transaction.transaction_data.tickets_currency.toUpperCase();
            this.chainCurrency = this.transaction.transaction_data.chain_currency;
            this.eventCurRate = this.transaction.transaction_data.event_currency_rate;
            this.usdCurRate = this.transaction.transaction_data.usd_currency_rate;
            this.eventName = this.transaction.transaction_data.event_name;
            this.totalTickets = this.transaction.transaction_data.total_tickets;
            this.userEmail = this.transaction.transaction_data.user_email;
            this.eventId = this.transaction.transaction_data.event_id;
            this.ticketPrice = parseFloat(this.transaction.transaction_data.tickets_price);
            this.ticketsAmount = parseFloat(this.transaction.transaction_data.tickets_amount);
            this.networkName = this.transaction.transaction_data.network;
            // console.log('getTransactionByUrl', this.ticketsPrice, this.ticketPrice, this.ticketsAmount);
            // this.transaction.amountUsd = this.walletConnectService.getShadowFromWei(this.transaction.transaction_data.value.toString()); // In USD
          }
          pendingTransaction = {txHash: this.transaction.transaction_hash, state: 'pending', transaction_data: this.transaction.transaction_data, dbResponse: this.transaction};
          this.checkAndSetNetwork(pendingTransaction);
          // this.startCheckingTransaction(pendingTransaction);
        } else if (response.code === 'success') {
          // console.log('Transaction is succes');
          this.transactionStatus = 'Success!'
          this.isChecking = false;
          this.dialogService.alertsModal('success', 'walletConnectSuccess', 3000, true);
          // TODO: to offer pass to the main page and login to ckeck the tikets
          // setTimeout(() => {
          //    this.router.navigate(['/order-status/1/1/2/1/4624/5.00/1']);
          // }, 5000);
        }
      },
      error => {
        console.log('Transaction error', error);
        if (error.code === 'invalid' || error.code === 'expired') {
          console.log('Transaction expired or invalid');
          this.dialogService.alertsModal('cryptoCurrency', 'urlHashIndalid', 3000, false);
          this.transactionStatus = 'Error';
          this.isChecking = false;
        } else {
          this.dialogService.alertsModal('errors', (error.code) ? error.code : 4 ,3000, false, error.log_id);
          this.transactionStatus = 'Error';
          this.isChecking = false;
        }
      });
    } else { // test without url hash
      this.transaction = {
        payment_id: '2524',
        transaction_data: {"accessList":[],"blockHash":"0x06871f2e5eb2a150a40f4f35683c79abd1897766be97e78a3ee883b8c240a2bd","blockNumber":14538571,"chainId":"0x1","from":"0xE37d1b9D240950F14Ca02977A17aAd0A34c16C99","gas":21000,"gasPrice":"36344942944","hash":"0x07e56d1f0aa85ccc6093fe25689554feb27f394828be40da0d8a63ae906802ff","input":"0x","maxFeePerGas":"36344942944","maxPriorityFeePerGas":"36344942944","nonce":9,"r":"0x675efe1ff817dfb692b6d390af16c09a13456aaca2b673f05e017e4a8ddb7105","s":"0x442b42ab099714656fca05b866b965ce24a9f72649ee1a6844869ad055ad93a3","to":"0xEc5aEE361F4d7aAf6135D19D6FcFD8568b1Bb186","transactionIndex":154,"type":2,"v":"0x0","value":"1637000000000000","pending":{"accessList":[],"blockHash":"0x06871f2e5eb2a150a40f4f35683c79abd1897766be97e78a3ee883b8c240a2bd","blockNumber":14538571,"chainId":"0x1","from":"0xE37d1b9D240950F14Ca02977A17aAd0A34c16C99","gas":21000,"gasPrice":"36344942944","hash":"0x07e56d1f0aa85ccc6093fe25689554feb27f394828be40da0d8a63ae906802ff","input":"0x","maxFeePerGas":"36344942944","maxPriorityFeePerGas":"36344942944","nonce":9,"r":"0x675efe1ff817dfb692b6d390af16c09a13456aaca2b673f05e017e4a8ddb7105","s":"0x442b42ab099714656fca05b866b965ce24a9f72649ee1a6844869ad055ad93a3","to":"0xEc5aEE361F4d7aAf6135D19D6FcFD8568b1Bb186","transactionIndex":154,"type":2,"v":"0x0","value":"1637000000000000","pending":{"check_wallet_url":"https:\/\/getin-nextgen.com\/en\/transaction\/53860905898301350460496597265993","accessList":[],"blockHash":"0x06871f2e5eb2a150a40f4f35683c79abd1897766be97e78a3ee883b8c240a2bd","blockNumber":14538571,"chainId":"0x1","from":"0xE37d1b9D240950F14Ca02977A17aAd0A34c16C99","gas":21000,"gasPrice":"36344942944","hash":"0x07e56d1f0aa85ccc6093fe25689554feb27f394828be40da0d8a63ae906802ff","input":"0x","maxFeePerGas":"36344942944","maxPriorityFeePerGas":"36344942944","nonce":9,"r":"0x675efe1ff817dfb692b6d390af16c09a13456aaca2b673f05e017e4a8ddb7105","s":"0x442b42ab099714656fca05b866b965ce24a9f72649ee1a6844869ad055ad93a3","to":"0xEc5aEE361F4d7aAf6135D19D6FcFD8568b1Bb186","transactionIndex":154,"type":2,"v":"0x0","value":"1637000000000000","pending":{"transaction_amount":1},"chain_currency":"Ether","transaction_amount":1},"chain_currency":"Ether","transaction_amount":1},"chain_currency":"Ether","transaction_amount":1},
        transaction_hash: '0x07e56d1f0aa85ccc6093fe25689554feb27f394828be40da0d8a63ae906802ff',
        transaction_status: 0
      };
      // this.transactionStatus = 'Pending...';
      pendingTransaction = {txHash: this.transaction.transaction_hash, state: 'pending', transaction_data: this.transaction.transaction_data, dbResponse: this.transaction};
      this.startCheckingTransaction(pendingTransaction);
    }
  }

  checkAndSetNetwork(pendingTransaction) {
    this.walletConnectService.setNetwork(this.networkName, this.chainCurrency).then(value => {
      if (value) {
        this.startCheckingTransaction(pendingTransaction);
      }
    });
  }

  startCheckingTransaction(pendingTransaction) { // transaction.transaction_hash, 'pending', transaction.transaction_data, transaction
    this.globals.startLoader();
    // console.log('Got Transaction', pendingTransaction);
    this.walletConnectService.getShadowTransactionByHash(pendingTransaction.txHash).then(response => {
      this.globals.stopLoader();
      // console.log('Got Transaction Response', response);
      if (response && response.blockHash && response.blockNumber) { // transaction status is success
        // this.transactionStatus = transaction.state;
        this.isChecking = false;
        // this.transaction.transaction_data = response;
        this.transactionStatus = 'Confirmation...';
        this.saveTransaction(response, pendingTransaction.state, pendingTransaction.transaction_data, pendingTransaction.dbResponse); // save transaction data into DB
      } else if (!response.blockHash && !response.blockNumber) {
        console.log('Transaction Without BlockHash', response);
        this.isChecking = false;
        this.transactionStatus = 'Pending.'
        // Show notice
        // Need to check again
      } else {
        console.log('Transaction Logical problem...', response);
        this.isChecking = false;
        // Show notice
        // Need to check again later
      }
    }).catch(error => {
      console.log('Get Pending Transaction error', error);
        // Show notice
        // Need to check again later
    });
  }

  checkTxExplorer() {
    // window.location.replace("https://kovan.etherscan.io/tx/" + this.transaction.transaction_hash);
    window.location.href = "https://kovan.etherscan.io/tx/" + this.transaction.transaction_hash;
  }

  saveTransaction(txHash, state?, transaction_data?, dbResponse?) {
    const res =  dbResponse && dbResponse.transaction_data ? dbResponse.transaction_data : false;
    this.globals.startLoader();
    // state && transaction_data ? txHash[state] = transaction_data : false;
    if (state && transaction_data) {
      this.prevStates.forEach(prev => {
        txHash[prev.state] = prev.data;
      });
      this.prevStates.push({state, data: transaction_data});
      txHash[state] = transaction_data;
    } else if (state === 'pending') {
      this.prevStates.push({state, data: txHash});
    }
    txHash.event_id = res && res.event_id ? res.event_id : '';
    txHash.event_name = res && res.event_name ?  res.event_name : '';
    txHash.total_tickets = res && res.total_tickets ?  res.total_tickets : '';
    txHash.user_email = res && res.user_email ?  res.user_email : '';
    txHash.chain_currency = res && res.chain_currency ?  res.chain_currency : '';
    txHash.transaction_amount = res && res.transaction_amount ?  res.transaction_amount : '';
    txHash.transaction_fee = res && res.transaction_fee ?  res.transaction_fee :  '';
    txHash.event_currency_rate = res && res.event_currency_rate ?  res.event_currency_rate : '';
    txHash.tickets_currency = res && res.tickets_currency ?  res.tickets_currency : '';
    txHash.tickets_price = res && res.tickets_price ?  res.tickets_price : '';
    txHash.tickets_price_without_fee = res && res.tickets_price_without_fee ?  res.tickets_price_without_fee : '';
    txHash.tickets_price_in_chain_cur_wo_fee = res && res.tickets_price_in_chain_cur_wo_fee ?  res.tickets_price_in_chain_cur_wo_fee : '';
    txHash.tickets_amount = res && res.tickets_amount ?  res.tickets_amount : '';
    txHash.usd_currency_rate = res && res.usd_currency_rate ?  res.usd_currency_rate : '';
    txHash.network =  res && res.network ?  res.network : '';
    // txHash.ticket_name = res && res.ticket_name ?  res.ticket_name : '';
    const params = {
      payment_id: dbResponse && dbResponse.payment_id ? dbResponse.payment_id : '',
      transaction_hash: txHash.hash,
      transaction_status: 1,
      // transaction_amount: res.transaction_amount ?  res.transaction_amount : this.transactionData.ticketPriceTotal,
      // transaction_from: txHash.from,
      // transaction_to: txHash.to,
      transaction_data: txHash //{transaction_amount: this.transactionData.ticketPriceTotal, txHash}
    };
    // console.log('before save transaction to back-end', params);
    this.isChecking = true;
    // this.transactionStatus = 'Success!'
    // this.globals.stopLoader();
    this.walletConnectService.saveWalletConnectTransaction(params).subscribe((response: any) => {
      this.globals.stopLoader();
      // console.log('Save Transaction response', response);
      if (response.data && response.data.url) {
        this.isChecking = false;
        this.transactionStatus = 'Success!'
        this.dialogService.alertsModal('success', 'walletConnectSuccess', 5000, true);
          // setTimeout(() => {
          // this.router.navigate([response.data.url]);
          // }, 10000);
      } else if (response.code === 'success' && !response.data.success) {
        // console.log('Transaction is pending...');
        // TODO: to offer pass to the main page and login to ckeck the tikets
        // this.dialogService.alertsModal('success', 'walletConnectTransaction', 5000, true);
      } else {
        console.log('Could not get transaction..');
        // this.dialogService.alertsModal('cryptoCurrency', 'walletTransactionSave', 3000, false);
      }
    });
  };

  copyToClipboard() {
    this.clipboardService.copyFromContent(this.transaction.transaction_hash);
    this.clipboardService.destroy();
    this.dialogService.alertsModal('success', 'couponCopied', 2000, true);
  }

}
